const getOrderValue = (product) => {
  return typeof product.order === "number"
    ? product.order
    : Number.MAX_SAFE_INTEGER
}

// return new array of products sorts by order value (ascending)
export const sortProductsByOrder = (products) => {
  return [...products].sort((a, b) => getOrderValue(a) - getOrderValue(b))
}
